import React from 'react';
import {Link} from 'react-router-dom';
import {DateTime} from 'components/UI/DateTime';
import {UploadImage} from 'components/UI/Image';
import {ShowIf} from 'components/utils';

class ItemDemand extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    const user = this.props.user ? this.props.user : null;
    const business = user && user.businesses.length > 0 ? user.businesses[0] : null;
    const businessAvatar = business ? business.logo : null;
    const userAvatar = user && user.avatar ? user.avatar : null;
    return (
      <div className="item-demand-wrap">
        <div className="item-demand">
          <Link to={`/demands/${this.props.id}`} className="item-demand-link">{this.props.content}</Link>
          <p className="item-demand-time"><DateTime dateTime={this.props.createdAt} /></p>
          <div className="item-demand-owner">
            <ShowIf condition={businessAvatar || userAvatar}>
              <div className="owner-demand-wrap-avata">
                <UploadImage transform="crop" className="item-image" width="25" height="25" type={businessAvatar ? 'BUSINESS' : 'USER'} image={businessAvatar ? businessAvatar : userAvatar}/>
              </div>
            </ShowIf>
            {user && business && user.businesses && <Link to={`/doanh-nghiep/${business.nameSlug}`} className="owner-demand-name">{business.name}</Link>}
            {user && !business && <div className="owner-demand-name">{user.name}</div> }
          </div>
        </div>
      </div>
    );
  }
}

export default ItemDemand;



// WEBPACK FOOTER //
// ./components/demand/ItemDemand.jsx